import React from 'react';
import { Container, Button, Form, Alert } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import useBackend, { CallAPI, Loading, SpinnerX } from '../../services/useBackend_v2';
import { Branding } from '../../services/misc';

export default function MyPage() {
    const { loading, data, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('/backend/mydata');

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const formDataObj = Object.fromEntries(formData.entries());
		const { errorsException } = await XCall('/backend/mydata', 'POST', 3000, { SystemID: "NS", MyData: formDataObj }, true);
		
		// if (!errorsException) {
		// 	setTimeout(() => {
		// 		setModalshowAddDevice(false);
		// 		Refresh();
		// 	}, 2000);
		// }        

        await CallAPI('/api/admin/UpdateInstanceMetaFromBackend', "PATCH", "{}");
    }

    if (!loading) {
        return (
            <ContentWrapper> 
                <Container>
                    <Sida>
                    <Rubrik>Mina Profil</Rubrik>

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Kontaktperson</Form.Label>
                            <Form.Control type="text" name ="contact" placeholder="Kontaktperson" defaultValue={data.myData.contact} id="formDataContact"/>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Telefon</Form.Label>
                            <Form.Control type="text" name="phone" placeholder="Telefon" defaultValue={data.myData.phone} id="formDataPhone" />
                        </Form.Group>                        

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" name="Email" placeholder="Email" defaultValue={data.myData.email} id="formDataEmail" disabled/>
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Företag</Form.Label>
                            <Form.Control type="text" name="company" placeholder="Företag" defaultValue={data.myData.company} id="formDataCompany"/>
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Orgnr</Form.Label>
                            <Form.Control type="text" name="orgnr" placeholder="Orgnr" defaultValue={data.myData.orgnr} id="formDataOrgnr" disabled/>
                        </Form.Group>    

                        <Form.Group className="mb-3" >
                            <Form.Label>Adress</Form.Label>
                            <Form.Control type="text" name="street01" placeholder="Gatuadress" defaultValue={data.myData.street01} id="formDataStreet01"/>
                        </Form.Group>    

                        <Form.Group className="mb-3" >
                            <Form.Label>Postnummer</Form.Label>
                            <Form.Control type="text" name="zip" placeholder="Postnr" defaultValue={data.myData.zip} id="formDataZip" />
                        </Form.Group>   

                        <Form.Group className="mb-3" >
                            <Form.Label>Ort</Form.Label>
                            <Form.Control type="text" name="city" placeholder="Ort" defaultValue={data.myData.city} id="formDataCity"/>
                        </Form.Group>        
                        
                        <Form.Group className="mb-3" >
                            <Form.Label>Land</Form.Label>
                            <Form.Control type="text" name="country" placeholder="Land" defaultValue={data.myData.country} id="formDataCountry"/>
                        </Form.Group>

                        <Form.Group className="mb-3" >
                            <Form.Label>Fakturatyp</Form.Label>
                            {/* onChange={e => {setState({invoiceType:e.target.value});  */}
                            <Form.Control as="select"  name="invoiceType" defaultValue={data.myData.invoiceType}>
                                <option value={1}>Faktura via post 40:-/månad</option>
                                <option value={2}>PDF-Faktura via E-post</option>
                                <option value={3}>E-Faktura</option>
                            </Form.Control>
                        </Form.Group>                             

                        <Form.Group className="mb-3" >
                            <Form.Label>E-faktura GLN</Form.Label>
                            <Form.Control type="text" name="invoiceGLN" placeholder="E-faktura GLN" defaultValue={data.myData.invoiceGLN} id="formDataInvoiceGLN"/>
                        </Form.Group>     

                        <Form.Group className="mb-3" >
                            <Form.Label>Mailadress för faktura</Form.Label>
                            <Form.Control type="text" name="invoiceMail" placeholder="Epost Faktura" defaultValue={data.myData.invoiceMail} id="formDataInvoiceMail"/>
                        </Form.Group>    

                        <Form.Group className="mb-3" hidden={!loading}>
                            <SpinnerX />
                        </Form.Group>

                        <Form.Group className="mb-3"  hidden={!resultVisible}>
                            <Alert variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                        </Form.Group>        

                        <Form.Group className="mb-3">
                            <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit">Spara</Button>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <a className="text-decoration-none" style={{color:'#000', fontSize:'16px'}} href="/instance/subscriptions">Mina Tjänster</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            <a className="text-decoration-none" style={{color:'#000', fontSize:'16px'}} href="/instance/invoices">Mina fakturor</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            <a className="text-decoration-none" style={{color:'#000', fontSize:'16px'}} href="/reports">Rapporter</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            <a className="text-decoration-none" style={{color:'#000', fontSize:'16px'}} href="/password/change">Byt lösenord</a>&nbsp;&nbsp;&nbsp;&nbsp;
                            <a className="text-decoration-none" style={{color:'#000', fontSize:'16px'}} href="/instance/terminate">Avsluta konto</a>&nbsp;&nbsp;&nbsp;&nbsp;
                        </Form.Group>
                    </Form>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);
    }
}